import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {QbTemplateDto} from "../model/QbTemplateDto";
import {IComponentController} from "angular";

class QbTemplateSelectController implements IComponentController {
    records: QbTemplateDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    templateType: string;
    showAll: Boolean;

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.client.bindAllQbTemplate(() => this.records);
        $dataHub.onConnected(this.reload);
    }

    reload = () => {
        this.$dataHub.qbTemplateSubscribeAndQuery().then(ret=>this.records=ret);
    };

    $onInit(): void {
    }
}

export default angular.module('component.qbTemplateSelect', [])
    .component('qbTemplateSelect', {
        template: require('./QbTemplateSelect.html'),
        controller: QbTemplateSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            templateType: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
